import request from './request'

/**
 * 获取订单列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页条数
 * @param {string} params.order_no - 订单号（可选）
 * @param {string} params.iccid - ICCID（可选）
 * @param {number} params.payment_status - 支付状态（-1=全部，0=待支付，1=已支付，2=支付失败）
 * @param {number} params.recharge_status - 充值状态（-1=全部，0=待充值，1=充值成功，2=充值失败）
 * @param {number} params.refund_status - 退款状态（-1=全部，0=无退款，1=退款中，2=已退款，3=退款失败）
 * @returns {Promise} - 返回订单列表数据
 */
export function getOrderList(params) {
  return request({
    url: '/fuyou/iccid/recharge/admin/order/list',
    method: 'post',
    data: {
      page: params.page || 1,
      page_size: params.page_size || 20,
      order_no: params.order_no || '',
      iccid: params.iccid || '',
      payment_status: params.payment_status !== undefined ? params.payment_status : -1,
      recharge_status: params.recharge_status !== undefined ? params.recharge_status : -1,
      refund_status: params.refund_status !== undefined ? params.refund_status : -1
    }
  })
}

/**
 * 获取订单详情
 * @param {string} orderNo - 订单号
 * @returns {Promise} - 返回订单详情数据
 */
export function getOrderDetail(orderNo) {
  return request({
    url: '/fuyou/iccid/recharge/admin/order/detail',
    method: 'post',
    data: {
      order_no: orderNo
    }
  })
}

/**
 * 更新充值状态
 * @param {Object} data - 更新数据
 * @param {string} data.order_no - 订单号（必填）
 * @param {number} data.status - 充值状态（必填）1=充值成功，2=充值失败
 * @param {string} data.remark - 备注（可选）成功时为操作说明，失败时为失败原因
 * @returns {Promise} - 返回更新结果
 */
export function updateRechargeStatus(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/update-recharge-status',
    method: 'post',
    data: {
      order_no: data.order_no,
      status: data.status,
      remark: data.remark || ''
    }
  })
}